// src/router/index.js
import { createRouter, createWebHistory } from "vue-router";
import { ElMessage } from "element-plus";
import routes from "./routes";
import userManager from "../services/oidcUserManager";

const router = createRouter({
  history: createWebHistory(),
  routes,
  linkActiveClass: "active",
});

const checkActiveSession = async () => {
  const user = await userManager.getUser();
  return !!(user && !user.expired);
};

router.beforeEach(async (to, from, next) => {
  if (to.meta?.title) document.title = to.meta.title;

  // Deixa o callback entrar sem checar sessão
  if (to.name === "oidc-callback") return next();

  let isAuthenticated = false;
  try {
    isAuthenticated = await checkActiveSession();
  } catch (error) {
    ElMessage.error("Erro ao verificar sessão ativa: " + (error?.message || error));
  }

  // Se estiver logado e for para /login, manda para /dashboard
  if (to.name === "login" && isAuthenticated) {
    return next("/dashboard");
  }

  // Protege rotas privadas
  if (to.matched.some(r => r.meta?.requiresAuth) && !isAuthenticated) {
    return next("/login");
  }

  next();
});

export default router;
